import { render, staticRenderFns } from "./product-targeting-strategy-tpl-use.vue?vue&type=template&id=6b66281f&scoped=true&"
import script from "./product-targeting-strategy-tpl-use.vue?vue&type=script&lang=js&"
export * from "./product-targeting-strategy-tpl-use.vue?vue&type=script&lang=js&"
import style0 from "./product-targeting-strategy-tpl-use.vue?vue&type=style&index=0&id=6b66281f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66281f",
  null
  
)

export default component.exports